import type { Palette, Theme } from "@mui/material"
import fp from "lodash/fp"

import type { AlertState } from "types/alerts.types"

import { getNumberFromZeroToMaxFromStr, mod } from "helpers/utils/common"
import { extraColorList } from "styles/themes/helpers"

export const getAlertStateColor = (triggered: boolean, theme: Theme): string => {
  return triggered ? theme.palette.error.main : theme.palette.primary.main
}

export const getBarPlotSeverityColor = (state: string, theme: Theme): string => {
  switch (state) {
    case "low":
      return theme.palette.secondary.main
    case "medium":
      return theme.palette.warning.main
    case "high":
      return theme.palette.error.main
    default:
      return theme.palette.primary.main
  }
}

export const getColorFromString = (str: string, palette: Palette): string => {
  const colorList = fp.flow(fp.values, fp.map("main"))(palette.extras)
  return colorList[getNumberFromZeroToMaxFromStr(str, colorList.length)]
}

export const getSequentialColor = (index: number): string => {
  const colorIdx = mod(index, extraColorList.length)
  return extraColorList[colorIdx]
}

export const getAccordionStateColor = (state: AlertState, theme: Theme): string => {
  switch (state) {
    case "open":
      return theme.palette.error.main
    case "silenced":
      return theme.palette.warning.main
    // A lighter grey for not triggered and a darker one for disabled, so the two read apart.
    case "notTriggered":
      return theme.palette.grey[400]
    case "disabled":
      return theme.palette.grey[600]
    default:
      return theme.palette.action.disabled
  }
}
